import { Component, Input, OnInit } from '@angular/core'
import { FormControl } from '@angular/forms'

@Component({
  selector: 'app-notify-automation-delayed',
  templateUrl: './notify-automation-delayed.component.html',
  styleUrls: ['./notify-automation-delayed.component.scss'],
})
export class NotifyAutomationDelayedComponent implements OnInit {
  @Input() ctrl: FormControl

  @Input() min = 0
  @Input() max = 36
  @Input() hidePlaceholder = false
  @Input() showLabel = true

  @Input() disabled = false

  constructor() {}

  ngOnInit(): void {}
}
